import React from 'react';
import './ContactPage.css';
import evanPoster from '../../assets/images/evan_poster.png';

function ContactPage() {
  return (
    <div className="contact-page">
      <span className="contact-eyebrow">Get in Touch</span>
      <h2>Evan Reid</h2>
      <div className="contact-rule"></div>
      <div className="contact-details">
        <img src={evanPoster} alt="Evan Reid" className="evan-poster" />
        <div className="contact-row">
          <p>Mobile: <a href="tel:0274518884">027 451 8884</a></p>
          <p>Email: <a href="mailto:evanreid@xtra.co.nz">evanreid@xtra.co.nz</a></p>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;